export interface IApprovalAction {
    name: string,
    id: number
}

export enum DefaultAction {
    NONE = -2,
    REASSIGN = -1,
}

export enum ApprovalType {
    BASIC = "Basic",
    CUSTOM = "CustomResponse",
}

export const defaultApprovalActions: IApprovalAction[] = [
    {
        name: "NONE",
        id: DefaultAction.NONE,
    }, {
        name: "Reassign",
        id: DefaultAction.REASSIGN,
    }
]

